import React, { useState, useEffect } from 'react';
import Translations from '../../services/translation.service';
import OcrCardScanner from './ocr_card_scanner';
import closeButtonOcr from '../../assets/img/DeleteOCR.svg';
import OcrService from '../../services/ocr_service.service';
import Spinner from '../shared/spinner.component';
import User from '../../services/user.service';
import OcrFieldsData from './ocr_fields_data';
import Settings from '../../services/settings.service';
import Storage from '../../services/storage.service';
import SpinnerKw from '../shared/spinner_kw';
import StmSummary from '../shared/storefront-summary';
import StorefrontTitle from '../shared/storefront-title.component';
import CloseIcon from "../../assets/img/iconCloseModalGrey.svg";
import FirebaseAnalytics from '../../services/analytics.service';
import CONSTANTS from '../../services/constants.service';

const subscriptions = [];
const OcrOptionType = props => {
    const [translationsKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {});
    const [loading, setLoading] = useState(false);
    const [loadingOverall, setLoadingOverAll] = useState(true);
    const [contactValidity, setContactValidity] = useState(false);
    const [frontImage, setFrontImage] = useState({
        imageFile: null,
        base64Resized: null
    });
    const [backImage, setBackImage] = useState({
        imageFile: null,
        base64Resized: null
    });
    const [validImageData, setValidImageData] = useState(false);
    const [ocrData, setOcrData] = useState({ ...Settings["ocr_fields_" + props.type] });
    const [imagesProccessed, setImagesProccessed] = useState(false);
    const [uploadedPercentage, setUploadedPercentage] = useState(null);
    const [addressValidity, setAddressValidity] = useState(false);
    const [proccessFinished, setProccessFinished] = useState(false);
    const [governorateAreas, setGovernorateAreas] = useState("");
    const [area, setArea] = useState("");
    const [bedoonType, setBedoonType] = useState(false);
    useEffect(() => {
        // if (Settings.on_boarding) {
        setLoading(true);
        Storage.getOrfetch("governorate_areas", OcrService.getGovernoratesAreas)
            .then(response => {
                setGovernorateAreas(response.data)
                setLoading(false);
                Storage.clear("governoratesInitiated");
            })
            .catch(err => {
                Storage.clear("governoratesInitiated");
                setLoading(false);
            });
        Storage.set("governoratesInitiated", true);
        // }
    }, []);


    useEffect(() => {
        setLoadingOverAll(false);
        subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                setTranslationsKeys(data);
            })
        );
        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        }

    }, []);

    const submitAddressData = (additonalData = null) => {
        if (!additonalData) return;
        const copyOcrData = {
            ...ocrData
        };
        let addressValidityCopy = true;
        for (const [, item] of Object.entries(additonalData)) {
            copyOcrData[item.key] = {
                ...item
            }
            if (!item?.valid)
                addressValidityCopy = false;
        }
        setOcrData(copyOcrData);
        setAddressValidity(addressValidityCopy);

    }

    const updateContactData = (newContact = null) => {
        // if (!newContact) return;s
        const copyOcrData = {
            ...ocrData
        };
        const valid = OcrService.checkFieldValidity(newContact, copyOcrData[311].validations);
        setContactValidity(valid)
        copyOcrData[311].value = newContact;
        copyOcrData[311].valid = valid;
        setOcrData(copyOcrData);
    }

    useEffect(() => {
        if (frontImage?.imageFile && backImage?.imageFile) {
            setLoading(true);
            const data = {
                "List": [
                    {
                        "ImageData": {
                            "image": frontImage?.imageFile?.split("base64,")[1]
                        },
                        light: 6,
                        page_idx: 0
                    },
                    {
                        "ImageData": {
                            "image": backImage?.imageFile?.split("base64,")[1]
                        },
                        light: 6,
                        page_idx: 1
                    }
                ],
                "processParam": {
                    "scenario": "FullProcess",
                    "doublePageSpread": true
                }
            }
            const onUploadProgress = (dataEvent) => {
                setUploadedPercentage(Math.round((dataEvent?.loaded * 100) / dataEvent?.total));
            }



            OcrService.checkImages(data, onUploadProgress)
                .then(response => {
                    const web_ocr_contact_number_length = JSON.parse(Storage.get("business", true))[
                        "web_ocr_contact_number_length"] ? JSON.parse(Storage.get("business", true))[
                    "web_ocr_contact_number_length"] : "";
                    if (response.data) {
                        let cardFieldsMappedData = OcrService.proccessImagesData(response.data, props.type, setBedoonType);
                        let ocrDataCopy = {
                            ...cardFieldsMappedData
                        }
                        let dataValidity = true;
                        let addressValidity = true;
                        let contactValid = true;
                        for (let item in ocrDataCopy) {
                            if (!ocrDataCopy[item]?.valid &&
                                item !== "full_address" &&
                                item !== "overallStatus" &&
                                ocrDataCopy[item]?.name !== "contact_number" &&
                                ocrDataCopy[item]?.show_address_modal !== true
                            ) {
                                dataValidity = false;
                                // break;
                            }
                            if (item === "77"
                            ) {
                                setArea(item?.value);
                            }

                            if (
                                item === "311"

                            ) {
                                ocrDataCopy[item].validations.minLength = web_ocr_contact_number_length;
                                ocrDataCopy[item].validations.maxLength = web_ocr_contact_number_length;
                                contactValid = OcrService.checkFieldValidity(ocrDataCopy[item].value, ocrDataCopy[item].validations);
                                ocrDataCopy[item].valid = contactValid;
                            }

                            if (!ocrDataCopy[item].valid &&
                                item !== "full_address" &&
                                item !== "overallStatus" &&
                                ocrDataCopy[item]?.name !== "contact_number" &&
                                ocrDataCopy[item]?.show_address_modal === true
                            ) {
                                addressValidity = false;
                                // break;
                            }
                        }
                        //not taking governate by address modal field
                        // if (ocrDataCopy["77"]?.valid) {
                        //     const dataGovernorates = OcrService.proccessGovernoratesAreas(governorateAreas, ocrDataCopy["77"].value);
                        //     if (dataGovernorates?.area && dataGovernorates?.governorate_id) {
                        //         // ocrData["area"].value = ocrData["77"].value;
                        //         // ocrData["77"].value = dataGovernorates.area;
                        //         ocrDataCopy["governorate"].value = dataGovernorates.governorate_id
                        //     }
                        // }
                        setValidImageData(dataValidity && ocrDataCopy?.overallStatus);
                        setAddressValidity(addressValidity && ocrDataCopy?.overallStatus);
                        setOcrData(ocrDataCopy);
                        setLoading(false);
                        setUploadedPercentage(null);
                        setImagesProccessed(!ocrDataCopy?.overallStatus || !dataValidity);
                        setProccessFinished(true);
                        setContactValidity(contactValid);
                    } else {
                        setLoading(false);
                        setUploadedPercentage(null);
                    }
                })
                .catch(error => {
                    setLoading(false)
                    setUploadedPercentage(null);
                })
        } else {
            setOcrData({ ...Settings["ocr_fields_" + props.type] });
            setValidImageData(false);
            setProccessFinished(false);
        }
        return () => { }
    }, [frontImage, backImage, props.type])




    const saveOcrData = () => {
        let ocrDataObject = {};
        let ocrAddressObject = {};
        for (let key of Object.keys(ocrData)) {
            if (ocrData[key].data_submition) {
                ocrDataObject = {
                    ...ocrDataObject,
                    [ocrData[key]["name"]]: ocrData[key].value
                }
            }
            if (ocrData[key].address_submition) {
                ocrAddressObject = {
                    ...ocrAddressObject,
                    [ocrData[key]["name"]]: ocrData[key].value === "" ? "" : ocrData[key].value.trimEnd()
                }
            }
            if (bedoonType && key === "26") {
                ocrDataObject = {
                    ...ocrDataObject,
                    [ocrData[key]["name"]]: ocrData[key].value === "" ? "B" : ocrData[key].value.trimEnd()
                }
            }
        }
        ocrDataObject = {
            ...ocrDataObject,
            signature: ""
        }
        let swapObjects =
        //ocrAddressObject["governorate_id"].value === "" ?
        {
            area: area
        }
        // : {};
        ocrAddressObject = {
            ...ocrAddressObject,
            ...swapObjects,
            // area_id:"Egaila"
            // governorate_id: "ahmadi",
            // area: "Area 1",
            // area_id: "Area1",
            // block: "10",
            // building: "5"
        }
        setLoading(true);
        OcrService.sendOcrData(ocrDataObject)
            .then(response => {
                if (response && response.data) {
                    OcrService.sendOcrAddress(ocrAddressObject)
                        .then(response => {
                            if (response && response.data) {
                                let ocrImagesData = {
                                    front_image: frontImage?.base64Resized ? frontImage.base64Resized.split("base64,")[1] : "",
                                    back_image: backImage?.base64Resized ? backImage.base64Resized.split("base64,")[1] : ""
                                };
                                OcrService.sendOcrImages(ocrImagesData)
                                    .then(response => {
                                        if (response.status === 201) {
                                            //ocr success images send
                                            Storage.clear("eligible_update_info");
                                            User.fetchFlowStatus();

                                        }
                                    })
                                    .catch(error => {
                                        //ocr images send error
                                        setLoading(false);
                                    })
                            } else {
                                setLoading(false);
                            }
                        })
                        .catch(err => { })
                } else {
                    //non success ocr data send

                    setLoading(false);
                }
            })
            .catch(error => {
                //ocr data send error response
                // Errors.handleError("Wrong data")
                // const flags=Storage.get("flags");
                // flags["OCRSubmitted"]=true;
                // Storage.set("flags",flags);
                // Flow.goTo();
                setLoading(false);
                return;
            });
    }

    const setImageScannedByType = (
        image,
        base64Resized,
        type
    ) => {
        if (type === "both") {
            if (frontImage?.imageFile && backImage?.imageFile) return;
            if (!frontImage?.imageFile) {
                setFrontImage({
                    imageFile: image,
                    base64Resized: base64Resized
                });
            } else if (!backImage.imageFile) {
                setBackImage({
                    imageFile: image,
                    base64Resized: base64Resized
                });
            }
        }
        // if (type === "front")
        //     setFrontImage({
        //         imageFile: image,
        //         base64Resized: base64Resized
        //     });
        // if (type === "back")
        //     setBackImage({
        //         imageFile: image,
        //         base64Resized: base64Resized
        //     });
    }

    const evaluateScannedImages = () => {
        FirebaseAnalytics.button_clicked(CONSTANTS.OCR_FLOW_SCREEN, "kw_buttons_next");
        saveOcrData();
    }

    let content = <Spinner />
    if (!loadingOverall) {
        content = (
            <div className='stf-ocr-conatiner'>
                <StorefrontTitle
                    title={translationsKeys[props.type + "_option_title"]}
                    desc={translationsKeys[props.type + "_option_desc"]}
                />
                <div className="ocr-box">
                    <div className="ocr-title">{translationsKeys["kw_ocr_scan"]}</div>
                    <div className="ocr-sub-title">{translationsKeys["kw_ocr_scan_disc"]}</div>
                    <div className="ocr-sub-title">
                        <ul>
                            <li>{translationsKeys["kw_ocr_image_type_disc_1"]}</li>
                            <li>{translationsKeys["kw_ocr_image_type_disc_2"]}</li>
                        </ul>
                    </div>
                    <div className="ocr-scanner-container">
                        <div className={`${(frontImage?.imageFile || backImage?.imageFile) ? "ocr-scan-item" : "ocr-scan-item-none"}`}>
                            <OcrCardScanner
                                scannerDescription={translationsKeys["kw_ocr_upload_image"]}
                                scannedImageBase64={(
                                    fileImg,
                                    base64Image
                                ) => setImageScannedByType(
                                    fileImg,
                                    base64Image,
                                    "both")}
                                disabled={loading || (frontImage?.imageFile && backImage?.imageFile)}
                            />
                        </div>
                        {frontImage.imageFile ?
                            <div className="ocr-scan-item">
                                <img className="scanned-image" src={frontImage.imageFile} alt="front-card-upload" />
                                {/* Use the below div for showing API Error */}
                                {/* <div className="error-tooltip">
                                    <div><img src={alertIcon} alt=""/>{translationsKeys["kw_ocr_image_error"]}</div>
                                </div> */}
                                <button disabled={loading} className="remove-scanned-image" onClick={() => {
                                    if (backImage.imageFile) {
                                        setFrontImage({ ...backImage });
                                        setBackImage({
                                            imageFile: null,
                                            base64Resized: null
                                        });
                                        setBedoonType(false);
                                    } else {
                                        setFrontImage({
                                            imageFile: null,
                                            base64Resized: null
                                        });
                                        setBedoonType(false);
                                    }
                                    // setValidImageData(true);
                                }} >
                                    <img className="close-ocr-icon" src={closeButtonOcr} alt="close-ocr-icon" />
                                </button>
                            </div>
                            : null
                        }

                        {backImage.imageFile ?
                            <div className="ocr-scan-item">
                                <img className="scanned-image" src={backImage.imageFile} alt="back-card-upload" />
                                {/* Use the below div for showing API Error */}
                                {/* <div className="error-tooltip">
                                    <div><img src={alertIcon} alt=""/>{translationsKeys["kw_ocr_image_error"]}</div>
                                </div> */}
                                <button disabled={loading} className="remove-scanned-image" onClick={() => {
                                    setBackImage({
                                        imageFile: null,
                                        base64Resized: null
                                    });
                                    // setValidImageData(true);
                                }} >
                                    <img className="close-ocr-icon" src={closeButtonOcr} alt="close-ocr-icon" />
                                </button>
                            </div>
                            : null
                        }

                    </div>
                    <div className='ocr-title'>{translationsKeys["kw_ocr_review"]}</div>
                    <div className='ocr-sub-title'>{translationsKeys["kw_ocr_review_disc"]}</div>
                    <OcrFieldsData ocrType={props?.type} data={ocrData} translationsKeys={translationsKeys} governorateAreas={governorateAreas}
                        submitAddressData={submitAddressData} setArea={setArea} updateContactData={updateContactData} proccessFinished={proccessFinished} />
                </div>
                <button onClick={evaluateScannedImages} className="common-button" disabled={!validImageData || !addressValidity || !contactValidity}>{translationsKeys["kw_buttons_next"]} </button>
                {loading && <div className="translation-loading-spinner"><SpinnerKw percentage={uploadedPercentage} /> </div>}
            </div>
        )
    }
    return (
        <>
            <div className="storefront-two-col-pg">
                {content}
                <StmSummary />
            </div>
            {(imagesProccessed && !validImageData) &&
                <div className='dialog address-modal'>
                    <div className='dialog-container'>
                        <div className="page-modal">
                            <div className="dialog-container-content form-container">
                                <div className="heading-btn-container">
                                    <h1>
                                        {translationsKeys["kw_image_proccessing_status"]}
                                    </h1>
                                    <span onClick={() => setImagesProccessed(false)}>
                                        <img src={CloseIcon} alt="" />
                                    </span>
                                </div>
                                <h4> {translationsKeys["kw_proccessing_failed_desc"]} </h4>
                                <button className="common-button address-btn" onClick={() => setImagesProccessed(false)}>{translationsKeys["kw_proccessing_rescan"]}</button>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}


export default OcrOptionType;